import { SecurityPageProps } from "models/security";
import { useEffect } from "react";
import { useHistory } from "react-router";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import { addTypeFlowState } from "redux/features/security/security-slice";
import { ClientStatus, isBlockedCard } from "utils/clientStatus";
import { getItemLocalStore } from "utils/storeUtils";
import AppButton from "../../../components/AppButton/AppButton";
import { LOCAL_STORE_CLIENTE } from "../../../constants";
import { RouteNames } from "../../../routes/routes";
import "./AtendimentoHome.css";

const AtendimentoHome = () => {
  const history = useHistory();
  const { statusCliente, cartaoAtual, cartaoAtualConvenio } =
    getItemLocalStore(LOCAL_STORE_CLIENTE);

  const { negotiatePage } = useAppSelector((state) => state.security);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (statusCliente === ClientStatus.COBRANCA && negotiatePage) {
      history.push(RouteNames.NEGOCIE);
    }
  }, [statusCliente, history, negotiatePage]);

  const teucardBloqueado = isBlockedCard(cartaoAtual?.status);
  const convenioBloqueado = isBlockedCard(cartaoAtualConvenio?.status);

  const clickVoltar = () => {};

  const handleAntecipationPurchase = () => {
    dispatch(addTypeFlowState("antecipacao"));
    const propsRouter: SecurityPageProps = {
      title: "Teu Atendimento",
      description: `<span>Para antecipar a compra, digite a <strong>senha</strong> do cartão.</span>`,
      nextStep: RouteNames.ATENDIMENTO_ANTECIPACAO,
      backStep: RouteNames.ATENDIMENTO_HOME,
    };

    history.push({
      pathname: RouteNames.SECURITY_CLIENTE_SENHA,
      state: { ...propsRouter },
    });
  };

  const handleBlock = () => {
    dispatch(addTypeFlowState("atendimento"));
    const propsRouter: SecurityPageProps = {
      title: "Teu Atendimento",
      description: `<span>Para bloquear seu TeuCard digite tua senha do cartão</span>`,
      nextStep: RouteNames.BLOQUEIO_SELECIONA_CARTAO,
      backStep: RouteNames.ATENDIMENTO_HOME,
    };

    history.push({
      pathname: RouteNames.SECURITY_CLIENTE_SENHA,
      state: { ...propsRouter },
    });
  };

  const handleLimit = () => {
    dispatch(addTypeFlowState("atendimento"));
    const propsRouter: SecurityPageProps = {
      title: "Teu Atendimento",
      description: `<span>Para consultar seu limite digite tua senha do cartão</span>`,
      nextStep: RouteNames.ATENDIMENTO_LIMITE,
      backStep: RouteNames.ATENDIMENTO_HOME,
    };

    history.push({
      pathname: RouteNames.SECURITY_CLIENTE_SENHA,
      state: { ...propsRouter },
    });
  };

  const handleExtract = () => {
    dispatch(addTypeFlowState("atendimento"));
    const propsRouter: SecurityPageProps = {
      title: "Teu Atendimento",
      description: `<span>Para consultar seu extrato digite tua senha do cartão</span>`,
      nextStep: RouteNames.ATENDIMENTO_EXTRATO,
      backStep: RouteNames.ATENDIMENTO_HOME,
    };

    history.push({
      pathname: RouteNames.SECURITY_CLIENTE_SENHA,
      state: { ...propsRouter },
    });
  };

  const handleFatura = () => {
    dispatch(addTypeFlowState("fatura"));
    const propsRouter: SecurityPageProps = {
      title: "Teu Atendimento",
      description: `<span>Para consultar a tua fatura, digite a <strong>senha</strong> do cartão.</span>`,
      nextStep: RouteNames.ATENDIMENTO_FATURA,
      backStep: RouteNames.ATENDIMENTO_HOME,
    };

    history.push({
      pathname: RouteNames.SECURITY_CLIENTE_SENHA,
      state: { ...propsRouter },
    });
  };
  const clienteEmCobranca = statusCliente === ClientStatus.COBRANCA;
  const botaoTeucardDesabilitado = clienteEmCobranca || teucardBloqueado;
  // COBRANCA reflete o status do TeuCard; Convênio nunca entra em cobrança.
  const desabilitaPorCobranca = clienteEmCobranca && convenioBloqueado;

  return (
    <div id="atendimento-home-content">
      <div id="titles">
        <h1 id="title">Teu Atendimento</h1>
        <h2 id="description">
          Bem-vindo! Agora, escolha a melhor opção para seguirmos com teu
          atendimento.
        </h2>
      </div>

      <div id="buttons-container">
        <div>
          <div className="column-a">
            <button
              className="normal"
              onClick={() => handleLimit()}
              disabled={desabilitaPorCobranca}
            >
              Limite
            </button>
            <button
              className="normal"
              onClick={() => handleFatura()}
              disabled={botaoTeucardDesabilitado}
            >
              Fatura
            </button>
            <button
              className="normal"
              onClick={() => handleAntecipationPurchase()}
              disabled={botaoTeucardDesabilitado}
            >
              Antecipação de compras
            </button>
          </div>

          <div className="column-b">
            <button
              className="normal"
              onClick={() => handleExtract()}
              disabled={botaoTeucardDesabilitado}
            >
              Extrato
            </button>
            <button
              className="normal"
              onClick={() => handleBlock()}
              disabled={desabilitaPorCobranca}
            >
              Bloqueio de cartao
            </button>
          </div>

          <AppButton
            hidden={true} // ? Esta opção está oculta temporariamente
            content="Fatura"
            route={RouteNames.HOME}
            outlined={false}
            width="330px"
            click={clickVoltar}
          />
        </div>

        <div>
          <AppButton
            hidden={true} // ? Esta opção está oculta temporariamente
            content="Desbloqueio"
            route={RouteNames.HOME}
            outlined={false}
            width="330px"
            click={clickVoltar}
          />
        </div>

        <AppButton
          content="Voltar"
          route={RouteNames.HOME}
          outlined={true}
          click={clickVoltar}
        />
      </div>
    </div>
  );
};

export default AtendimentoHome;
